module.exports = __webpack_public_path__ + "static/media/get-a-job-in-the-defence.5c0751fc.jpg";